import React from 'react';
import { Dialog, Box, Typography, Button, CircularProgress, useTheme, useMediaQuery } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { getModalStyles } from './DeleteConfirmationModalCss';

const DeleteConfirmationModal = ({ open, accountEnding, onConfirm, onCancel, isDeleting }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const styles = getModalStyles(theme, isMobile);

    return (
        <Dialog
            open={open}
            onClose={() => !isDeleting && onCancel()}
            PaperProps={{
                sx: styles.paper
            }}
        >
            <Box sx={styles.container}>
                <Box sx={styles.iconWrapper}>
                    <DeleteIcon />
                </Box>
                
                <Typography variant="h6" sx={styles.title}>
                    Remove Bank Account?
                </Typography>
                
                <Typography variant="body2" color="text.secondary" sx={styles.subtitle}>
                    Are you sure you want to remove bank account ending in {accountEnding}? This action cannot be undone.
                </Typography>
                
                <Box sx={styles.actionsContainer}>
                    <Button
                        fullWidth
                        variant="outlined"
                        onClick={onCancel}
                        disabled={isDeleting}
                        sx={styles.cancelButton}
                    >
                        Cancel
                    </Button>
                    <Button
                        fullWidth
                        variant="contained"
                        color="error"
                        onClick={onConfirm}
                        disabled={isDeleting}
                    >
                        {isDeleting ? <CircularProgress size={24} color="inherit" /> : 'Delete'}
                    </Button>
                </Box>
            </Box>
        </Dialog>
    );
};

export default DeleteConfirmationModal;
